module.exports = __webpack_public_path__ + "static/img/87-2.a62efd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/87-2.jpg
// module id = BPcg
// module chunks = 0